var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoaderinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M50 5c0-2.761-2.244-5.026-4.992-4.75A50 50 0 1 0 99.75 54.992C100.026 52.244 97.761 50 95 50s-4.968 2.247-5.312 4.987a40 40 0 1 1-44.675-44.675C47.753 9.968 50 7.762 50 5Z",
  fill: "#202ECF"
})));
export default SvgLoaderinline;